import { createSlice } from '@reduxjs/toolkit';
const initialState = { keyword: '', data: [] };
const conflictModal = createSlice({
  name: 'conflictModal',
  initialState,
  reducers: {
    showconflictModal: (state, action) => {
      return action.payload;
    },
    hideconflictModal: state => {
      return initialState;
    }
  }
});
export const { showconflictModal, hideconflictModal } = conflictModal.actions;
export default conflictModal;
